import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

// const SERVER_URL = `http://localhost:4010/subtitles`;
const SERVER_URL = `${process.env.REACT_APP_SITEURL}/userSaveWord`;

const saveWordApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/saveWord`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await saveWordApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getDetalisListOfUserWordsApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/getDetalisListOfUserWords?limit=${paginate.perPage || 10
      }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getDetalisListOfUserWordsApi(data, paginate)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const deleteWordApi = async (dataObject) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/deleteWord`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.delete(url, {
      data: dataObject,
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await deleteWordApi(dataObject)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const deleteWordsByWordApi = async (dataObject) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/deleteWordsByWord`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.delete(url, {
      data: dataObject,
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await deleteWordsByWordApi(dataObject)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getListOfWordGroupsApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/getListOfWordGroups?limit=${paginate.perPage || 50
      }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getListOfWordGroupsApi(data, paginate)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getShortListOfWordGroups = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/getShortListOfWordGroups`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getShortListOfWordGroups(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};


const getListOfUserWordsByGroupApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/getListOfUserWordsByGroup?limit=${paginate.perPage || 50
      }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getListOfUserWordsByGroupApi(data, paginate)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};


const editWordApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/editWord`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editWordApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const addNewWordGroupApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/addNewWordGroup`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await addNewWordGroupApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const editWordGroupNameApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/editWordGroupName`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editWordGroupNameApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const removeWordGroup = async (dataObject) => {
  try {
    const url = `${SERVER_URL}/api/v1/userSaveWord/removeWordGroup`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.delete(url, {
      data: dataObject,
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await removeWordGroup(dataObject)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

export {
  saveWordApi,
  getDetalisListOfUserWordsApi,
  deleteWordApi,
  deleteWordsByWordApi,
  getListOfWordGroupsApi,
  getShortListOfWordGroups,
  getListOfUserWordsByGroupApi,
  editWordApi,
  addNewWordGroupApi,
  editWordGroupNameApi,
  removeWordGroup,
};
